import ChartCard from './ChartCard';
import PhoenixChartDetails from './PhoenixChartDetails';
import ChartHorizontal from './ChartHorizontal';
import ChartMicro from './ChartMicro';
import ChartPreview from './ChartPreview';
import MicroIcon from '../shared/MicroIcon';
import Icon from 'components/Icon';

export const card = ChartCard;
export const details = PhoenixChartDetails;
export const micro = ChartMicro;
export const horizontal = ChartHorizontal;
export const icon = MicroIcon(Icon.OPTIONS.CHART_BAR_VERTICAL);
export const preview = ChartPreview;
